import { SET_API_ME } from "./actionTypes";

// IMPORTANT: In TUserInfo keep only things from /api/me otherwise you'll break logic in components
export type TUserInfo = {
  _2fa_enabled: boolean;
  can_withdraw: boolean;
  certification_status: string;
  tier: string;
  agreements: TUserAgreements;
  country: string;
  hnw?: boolean;
  full_name: string;
  id: number;
  investor_id: number;
  investor_kyc: boolean;
  is_certified: boolean;
  is_verified: boolean;
  nickname: string;
  organizational: boolean;
  premium_membership: boolean;
  profile_id: number;
  membership: string;
  restricted_investing_cayman: boolean;
  tax_id_number: number;
  us_investor: boolean;
  us_resident: boolean;
  verification_status: string;
  is_certified_or_selfcertified: boolean;
  avatar_url: string;
  has_investments: boolean;
  can_stake: boolean;
  accessing_funds_agreement_created_at: boolean;
  restricted_by_user_statement: boolean;
  timelock_balance?: number;
  bitcoin_journey_step: number;
  sell_restricted_by_admin?: boolean;
  buy_restricted_by_admin?: boolean;
  sell_restricted_by_pep_sanction?: boolean;
  buy_restricted_by_pep_sanction?: boolean;
  sell_restricted_by_user_statement?: boolean;
  buy_restricted_by_user_statement?: boolean;
  sell_restricted_by_risk_rating?: boolean;
  buy_restricted_by_risk_rating?: boolean;
  sell_restricted_by_tier?: boolean;
  buy_restricted_by_tier?: boolean;
  sell_restricted_by_country_uk?: boolean;
  buy_restricted_by_country_uk?: boolean;
  sell_restricted_by_2fa?: boolean;
  buy_restricted_by_2fa?: boolean;
};

export type TUserAgreements = {
  crypto_deposits: boolean;
  crypto_trading: boolean;
  crypto_withdrawals: boolean;
  eth_staking: boolean;
};

const initialState = null;
function reducer(state: TUserInfo | null = initialState, action: any) {
  switch (action.type) {
    case SET_API_ME:
      return action.payload !== false
        ? {
            ...action.payload,
          }
        : false;

    default:
      return state;
  }
}

export default reducer;
